import LibraryAdd from '@apps/truevail/admin/components/library_add'
import MJSONPreview from '@admin/components/mjson_preview'
import TagsToken from '@apps/crm/admin/tokens/tags'
import Details from '@admin/components/details'
import Button from '@admin/components/button'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import Publish from '../publish'
import Clone from '../clone'
import Edit from '../edit'
import React from 'react'

const Overview = ({ social_campaign }, { admin, provider }) => {

  const design_url = social_campaign.design_url ? {
    label: social_campaign.design_url,
    className: 'link',
    link: social_campaign.design_url
  } : null

  const contentlibrary_url = {
    label: `${provider.admin_host}/${admin.team.subdomain}/contentlibrary/social_campaigns/${social_campaign.code}`,
    className: 'link',
    link: `${provider.admin_host}/${admin.team.subdomain}/contentlibrary/social_campaigns/${social_campaign.code}`
  }

  const details = {
    audits: `truevail_social_campaigns/${social_campaign.id}`,
    comments: `truevail_social_campaigns/${social_campaign.id}`,
    header: <MJSONPreview entity={ social_campaign.variants[0] } table="truevail_social_campaign_variants" />,
    sections: [
      {
        title: 't(Social Campaign Details)',
        items: [
          { label: 't(Title)', content: social_campaign.title },
          { label: 't(Type)', content: social_campaign.type.toUpperCase() },
          { label: 't(Design URL)', content: design_url ? <Button { ...design_url } /> : null },
          { label: 't(Allow Randomization)', content: social_campaign.allow_randomization ? 't(Yes)' : 't(No)' }
        ]
      },
      {
        title: 't(Library Details)',
        items: [
          { label: 't(URL)', content: social_campaign.status === 'published' ? <Button { ...contentlibrary_url } /> : null },
          { label: 't(Folders)', content: social_campaign.folders.length > 0 ? social_campaign.folders.map(folder => folder.title).join(', ') : null },
          { label: 't(Tags)', content: social_campaign.tags.length > 0 ? <TagsToken tags={ social_campaign.tags } /> : null }
        ]
      }
    ]
  }
  
  if(social_campaign.deleted_at !== null) {
    details.alert = { color: 'red', message: 't(This social campaign was deleted)' }
  } else if(social_campaign.status === 'draft') {
    details.alert = { color: 'grey', message: 't(This social campaign is not available in the library)' }
  } else if(social_campaign.status === 'translating') {
    details.alert = { color: 'teal', message: 't(This social campaign is being translated)' }
  } else if(social_campaign.status === 'published') {
    details.alert = { color: 'green', message: 't(This social campaign is available in the library)' }
  }

  return <Details { ...details } />

}

Overview.contextTypes = {
  admin: PropTypes.object,
  provider: PropTypes.object
}

Overview.propTypes = {
  social_campaign: PropTypes.object
}

const mapPropsToPanel = (props, context) => ({
  title: 't(Overview)',
  panel: <Overview social_campaign={ props.social_campaign } />,
  tasks: {
    items: [
      {
        label: 't(Edit Campaign)',
        svg: 'square_pen',
        modal: <Edit social_campaign={ props.social_campaign } />
      },
      {
        label: 't(Duplicate Campaign)',
        svg: 'copy',
        modal: <Clone social_campaign={ props.social_campaign } />
      },
      {
        label: 't(Add to Library)',
        svg: 'book_plus',
        show: props.social_campaign.status === 'draft',
        modal: <LibraryAdd scope="agency" entity="social_campaigns" record={ props.social_campaign } />
      },
      {
        label: 't(Remove from Library)',
        svg: 'book_minus',
        show: props.social_campaign.status === 'published',
        request: {
          endpoint: `/api/admin/truevail/agency/social_campaigns/${props.social_campaign.id}/unpublish`,
          method: 'PATCH',
          onSuccess: () => context.flash.set('success', 't(Successfully removed this social campaign from the library)'),
          onFailure: () => context.flash.set('error', 't(Unable to remove this social campaign from the library)')
        }
      },
      {
        label: 't(Publish Advisor Campaigns)',
        svg: 'users_round',
        modal: <Publish social_campaign={ props.social_campaign } />
      },
      {
        label: 't(Delete Campaign)',
        svg: 'trash',
        show: props.social_campaign.status === 'draft',
        confirm: 't(Are you sure you want to delete this campaign? You will also delete all of the associated workflows and performance data)',
        deletable: true,
        request: {
          endpoint: `/api/admin/truevail/agency/social_campaigns/${props.social_campaign.id}`,
          method: 'DELETE',
          onSuccess: () => {
            context.flash.set('success', 't(Successfully deleted social campaign)')
            context.router.goBack()
          },
          onFailure: () => context.flash.set('error', 't(Unable to deletel social campaign)')
        }
      }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
